import { fabric } from 'fabric';
import PolicyRect from '../policy_rect/PolicyRect';
import { ProgramPolicy } from '@/types/Programs';

export const TYPE = 'custom-policy-rect';

const CustomPolicyRect = fabric.util.createClass(PolicyRect, {
  type: TYPE,
  initialize(opts: fabric.PolicyRectOptions): void {
    if (!opts.policy.p_e_flag) {
      opts.policy.p_e_flag = 'Primary';
    }

    this.callSuper('initialize', opts);

    this.type = TYPE;
  },

  updatePolicyData(policy: ProgramPolicy): void {
    this.policy = policy;
    this.callSuper('updatePolicyData', policy);
  },
});

CustomPolicyRect.fromObject = function (obj: fabric.Object, fn: (obj: fabric.Object) => void) {
  const customPolicyRect = new CustomPolicyRect(obj);
  if (fn) fn(customPolicyRect);
  return customPolicyRect;
};

export default CustomPolicyRect;
